import { SUPPORTED_LANGS, LANG_INFO } from "../api";

export default function LangChips({ value, onChange, available }) {
  const langs = available?.length ? available : SUPPORTED_LANGS;
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="lang-chips">
      {langs.map((L) => {
        const active = L === value;
        const info = LANG_INFO[L];
        return (
          <button
            key={L}
            onClick={() => onChange(L)}
            data-testid={`lang-chip-${L}`}
            className={`shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border transition-all text-xs font-semibold tracking-wider ${
              active
                ? "bg-brand text-white border-brand shadow-sm"
                : "bg-white text-ink border-border hover:border-brand/40"
            }`}
          >
            <span className="text-base leading-none">{info.flag}</span>
            <span>{L.toUpperCase()}</span>
          </button>
        );
      })}
    </div>
  );
}
